import { render } from "./CurricullumVitae.vue?vue&type=template&id=79dda3ac"
import script from "./CurricullumVitae.vue?vue&type=script&lang=js"
export * from "./CurricullumVitae.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__